import styled from "styled-components";
import theme from "../../../Styles/theme";

export const Container = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    padding:12px;
`;

export const Title = styled.h5`
    color: ${theme.colors.dark};
    font-size: max(1.5vw,18px);
    font-weight:bold;
    text-align:left;
    width:100%;
`;

export const Message = styled.div`
 color: ${theme.colors.dark};
    font-size: max(1.2vw,15px);
`;